'use client';

// TODO: this file does not adhere to our routine standards, once botpress sdk is mature and we have more understanding then we should refactor it
import { useRouter, useSearchParams } from 'next/navigation';
import { Suspense, useEffect, useMemo, useRef, useState } from 'react';

import { HebaLoader } from 'components/atomic/atoms';
import { useUIContext } from 'components/context/uiContext/ManagedUiContext';
import StandardLayout from 'components/layout/StandardLayout';
import {
  BOTPRESS_WEBCHAT_SCRIPT_URL,
  WEBCHAT_HEBA_CONFIGURATION_STRING
} from 'config/botpressWebchatHeba';
import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';
import { sendBotpressHebaWelcomeMessageToWebchat } from 'services/planEventWithHeba.service';

const botPressSrcDoc = `
<!DOCTYPE html>
<html lang="en">
  <head>
    <style>

      #webchat-container {
        height: 100%;
        position: relative;
        width: 100%;
      }

      /* Hide the FAB */
      .bpFab {
        display: none !important;
      }

      /* Make the chat window full width and height */
      .bpWebchat {
        bottom: 0 !important;
        height: 100% !important;
        left: 0 !important;
        max-height: 100% !important;
        position: absolute !important;
        right: 0 !important;
        top: 0 !important;
        transform: none !important;
        width: 100% !important;
      }

      /* Remove media query styles for larger screens as we want full width on all devices */
      @media (min-width: 768px) {
        .bpWebchat {
          bottom: 0 !important;
          right: 0 !important;
          width: 100% !important;
        }
      }

      @media (max-width: 700px) {
        .bpWebchat {
          height: 90% !important;
          max-height: 90% !important;
        }

        /* Keep this to Prevent scrolling on the page when the chat is open on mobile */
        :has(.bpOpen) {
          overflow: hidden;
        }
      }

    </style>
  </head>
  <body>
    <script src="${BOTPRESS_WEBCHAT_SCRIPT_URL}"></script>
    <script>
      window.botpress.on("webchat:ready", () => {
        setTimeout(() => { // TODO: may be for some reason in some cases this event is not captured in react component, so we are delaying by 2 seconds
          window.parent.postMessage({ action: "webchat:ready:custom" }, "*");
        }, 2000);
      });

      window.botpress.on("webchat:closed", () => {
        window.parent.postMessage({ action: "webchat:closed:custom" }, "*");
      });

      window.botpress.on('conversation', (event) => {
        setTimeout(() => { // TODO: may be for some reason in some cases this event is not captured in react component, so we are delaying by 2 seconds
          window.parent.postMessage({ action: "conversation:custom" }, "*");
        }, 2000);
      });

      window.botpress.on('*', (event) => {
        console.log('heba iframe event: ', event);
      });

      window.addEventListener("message", (event) => {
        console.log('heba iframe custom event: ', event);
      });

      window.botpress.init(${WEBCHAT_HEBA_CONFIGURATION_STRING});
    </script>
  </body>
</html>
`;

let outerLoader = 0;
let innerLoader = 0;

const BotpressWebchatHeba = ({
  isBotpressWebchatReadyForConversation,
  router,
  setIsBotpressWebchatReadyForConversation,
  setShowToast
}) => {
  const webchatReference = useRef(null);

  const isBotpressWebchatReadyForConversationRef = useRef(
    isBotpressWebchatReadyForConversation
  );

  useEffect(() => {
    isBotpressWebchatReadyForConversationRef.current =
      isBotpressWebchatReadyForConversation;
  }, [isBotpressWebchatReadyForConversation]);

  // TODO: in some wired cases bridgeIframeToComponent is not invoked as we miss to register events - so we are trying to open it again after 7 seconds
  useEffect(() => {
    setTimeout(() => {
      window?.botpress?.open();
    }, 7000);
  }, []);

  const keepWaitingForBotpressWebchatConversation = () => {
    let conversationCheckIntervalId;
    const checkBotpressConversationAvailable = () => {
      const isReady = isBotpressWebchatReadyForConversationRef.current;
      if (isReady) {
        clearInterval(conversationCheckIntervalId);
      } else if (window.botpress?._client?._state?.conversationId) {
        // TODO: this is a hack, we should not exploit undocumented properties, they are bound to change
        setIsBotpressWebchatReadyForConversation(true);
      }
    };
    conversationCheckIntervalId = setInterval(
      checkBotpressConversationAvailable,
      1500
    );
  };

  const keepAttemptingToOpenBotpressTillConversationIsReady = () => {
    let intervalId;
    const checkAndOpenBotpress = () => {
      const isReady = isBotpressWebchatReadyForConversationRef.current;
      if (isReady) {
        clearInterval(intervalId);
      }
      window.botpress.open();
    };
    intervalId = setInterval(checkAndOpenBotpress, 1500);
    keepWaitingForBotpressWebchatConversation();
  };

  useEffect(() => {
    const bridgeIframeToComponent = () => {
      if (!window.botpress && webchatReference.current.contentWindow.botpress) {
        window.botpress = webchatReference.current.contentWindow.botpress;
        window.botpress.on('*', (event) => {
          console.log('heba react event', event);
        });
        window.botpress.on('error', (error) => {
          setShowToast({
            message: `Botpress event error: ${error.message}`,
            show: true,
            status: false
          });
        });
        keepAttemptingToOpenBotpressTillConversationIsReady();
      }
    };

    const handleMessage = (event) => {
      const action = event.data?.action;

      switch (action) {
        case 'webchat:closed:custom':
          router.replace(
            getPageURL({
              pageName: ROUTE_CONFIG.HOME_PAGE.label
            })
          );
          break;
        case 'webchat:ready:custom':
          bridgeIframeToComponent();
          break;
        case 'conversation:custom':
          bridgeIframeToComponent();
          if (!isBotpressWebchatReadyForConversation) {
            setIsBotpressWebchatReadyForConversation(true);
          }
          webchatReference.current.contentWindow.postMessage(
            { action: 'sample' },
            '*'
          );
          break;
        default:
          break;
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  console.log({
    innerLoader: ++innerLoader,
    isBotpressWebchatReadyForConversationRef:
      isBotpressWebchatReadyForConversationRef?.current
  });

  return (
    <>
      {!isBotpressWebchatReadyForConversation && <HebaLoader />}
      <div
        className='webchat'
        style={{ height: '100vh', width: '100vw' }}
      >
        <iframe
          ref={webchatReference}
          srcDoc={botPressSrcDoc}
          style={{ border: 'none', height: '100%', width: '100%' }}
          sandbox='allow-scripts allow-same-origin allow-popups allow-forms'
        />
      </div>
    </>
  );
};

const PlanEventWithHeba = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const query = useMemo(
    () => Object.fromEntries(searchParams.entries()),
    [searchParams]
  );

  const { isHostIdentityAvailable } = useUIContext();

  const [showToast, setShowToast] = useState({
    message: '',
    show: false,
    status: false
  });

  const [
    isBotpressWebchatReadyForConversation,
    setIsBotpressWebchatReadyForConversation
  ] = useState(false);
  const [isLeadMarketingReferencePosted, setIsLeadMarketingReferencePosted] =
    useState(false);

  console.log({
    outerLoader: ++outerLoader,
    isBotpressWebchatReadyForConversation,
    isLeadMarketingReferencePosted
  });

  useEffect(() => {
    const insertTracker =
      isHostIdentityAvailable &&
      isBotpressWebchatReadyForConversation &&
      !isLeadMarketingReferencePosted;

    if (insertTracker) {
      sendBotpressHebaWelcomeMessageToWebchat({
        query,
        setIsLeadMarketingReferencePosted,
        setShowToast
      });
    }
  }, [isHostIdentityAvailable, isBotpressWebchatReadyForConversation]);

  return (
    <StandardLayout
      {...{
        setShowToast,
        showHeader: false,
        showLoader: !isBotpressWebchatReadyForConversation,
        showToast
      }}
    >
      <BotpressWebchatHeba
        {...{
          isBotpressWebchatReadyForConversation,
          router,
          setIsBotpressWebchatReadyForConversation,
          setShowToast
        }}
      />
    </StandardLayout>
  );
};

export default function PlanEventWithHebaClient() {
  return (
    <Suspense fallback={<HebaLoader />}>
      <PlanEventWithHeba />
    </Suspense>
  );
}
